import { render, staticRenderFns } from "./TransferenciaPremiosPresupuesto.vue?vue&type=template&id=69e3b418&"
import script from "./TransferenciaPremiosPresupuesto.vue?vue&type=script&lang=js&"
export * from "./TransferenciaPremiosPresupuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports